module.exports = __webpack_public_path__ + "img/check.b66ef04a.svg";